export const getPipelineInitialState = () => '';
